import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class MccService {
  constructor(private http: HttpClient) { }

  public getMccAbecsByCnpj(cnpj: string, institution: string, serviceContract: number): Observable<string> {
    const params = new HttpParams()
      .set('institution', institution)
      .set('service-contract', serviceContract?.toString())
      .set('cpfCnpj', cnpj);

    return this.http
      .get<number>(`${environment.apiUrls.mcc}/by-cnpj`, { params })
      .pipe(map((res) => (res !== null && res !== undefined ? res.toString() : '')));
  }
}
